module.exports = __webpack_public_path__ + "static/media/report-aura-background-v2.51e70ee0.svg";